import React, { useState } from 'react';
import {
  Box,
  Text,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Flex,
  Spinner,
  useColorModeValue,
  Image,
  VStack,
} from '@chakra-ui/react';
import bandpic from "../../resources/child-6080185_1280.jpg";
import axios from "axios";
import EnrolmentForm from '../Components/EnrolmentForm';
import { EnrolmentData } from "../Common/types";
import { useToast } from "@chakra-ui/react";
import { useTenant } from "../Routers/TenantContextProvider";
import BackGroundImage from "../../resources/PlatformBackround.png"

  const EnrolmentPage = () => {
  
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [enrolmentNo, setEnrolmentNo] = useState<number | null>(null);
  const [message, setMessage] = useState<string>("");
  const [formEnrolmentData, setFormEnrolmentData] = useState<EnrolmentData>();
  const [formReset, setFormReset] = useState(false);

  const overlayColor = useColorModeValue("rgba(255, 255, 255, 0.85)", "rgba(0, 0, 0, 0.65)");
  const textColor = useColorModeValue("gray.800", "whiteAlpha.900");
  const ctaColorScheme = useColorModeValue("blue", "cyan");

  const toast = useToast();

  // Access tenant context
  const { tenant, loading, error } = useTenant();

  if (loading) {
            return (
              <Flex justify="center" align="center" h="100vh">
                <Spinner size="xl" />
              </Flex>
            );
          }
        
          if (error || !tenant) {
            return (
              <Flex justify="center" align="center" h="100vh">
                <Text color="red.500" fontSize="lg">
                  Failed to load tenant details.
                </Text>
              </Flex>
            );
          }

  const savePublicEnrolment = async (enrolmentData: EnrolmentData) => {
    setFormEnrolmentData(enrolmentData);
    console.log("enrolment_data", enrolmentData);
    try {
      const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
      const response = await axios.post(apiurl+"/public/submit-enrolment", enrolmentData, {
          headers: {
              "Content-Type": "application/json",
            },
        });
        if (response.data.isDuplicate) {
          // If duplicate detected, show confirmation dialog
         // setMessage("A similar enrolment already exists for this student. Confirm to proceed if this is a new enrolment.");
          //setShowConfirmation(true);
          onOpen(); // Show confirmation modal
        } else {
          // Enrolment successful
          setEnrolmentNo(response.data.enrolmentNo);
        //  setMessage("Enrolment successfully submitted. Please note Enrolment No. for Future Correspondence "+response.data.enrolmentNo);

        toast({
          title: "Enrolment Submitted",
          description: `Enrolment Details are sent to you through email, Enrolment No: ${response.data.enrolmentNo}`,
          status: "success",
          duration: 6000,
          isClosable: true,
          position: "top",
        });

          setFormReset(true); // Signal the form to reset
          // Reset the flag after the form resets
          setTimeout(() => setFormReset(false), 0); // Ensure resetForm doesn't stay true
        }
      console.log("Enrolment created:", response.data);
    } catch (error) {
          if (axios.isAxiosError(error) && error.response) {
                  const status = error.response.status;

                  toast({
                    title: "Error",
                    description:
                      status === 429
                        ? "You have exceeded the rate limit. Please try again later."
                        : error.response.data.detail || "An unexpected error occurred.",
                    status: "error",
                    duration: 6000,
                    isClosable: true,
                    position: "top",
                  });
                } else {
                  toast({
                    title: "Network Error",
                    description: "Unable to connect to the server. Please check your network.",
                    status: "error",
                    duration: 6000,
                    isClosable: true,
                    position: "top",
                  });
                }
    }
  };

  const handleConfirm = async () => {
    try {
      const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
      const response = await axios.post(apiurl+"/public/create-enrolment", formEnrolmentData, {
        headers: {
            "Content-Type": "application/json",
          },
      });
      // Enrolment successful
      setEnrolmentNo(response.data.enrolmentNo);
     // setMessage("Enrolment successfully submitted. Please note Enrolment No. for Future Correspondence"+response.data.enrolmentNo);
      toast({
        title: "Enrolment Submitted",
        description: `Enrolment No: ${response.data.enrolmentNo}`,
        status: "success",
        duration: 6000,
        isClosable: true,
        position: "top",
      });
      onClose();

      setFormReset(true); // Signal the form to reset
      // Reset the flag after the form resets
      setTimeout(() => setFormReset(false), 0); // Ensure resetForm doesn't stay true

      //setShowConfirmation(false);
    } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
        const status = error.response.status;

        toast({
          title: "Error",
          description:
            status === 429
              ? "You have exceeded the rate limit. Please try again later."
              : error.response.data.detail || "An unexpected error occurred.",
          status: "error",
          duration: 6000,
          isClosable: true,
          position: "top",
        });
      } else {
        toast({
          title: "Network Error",
          description: "Unable to connect to the server. Please check your network.",
          status: "error",
          duration: 6000,
          isClosable: true,
          position: "top",
        });
      }
    }
  };         

  return (

    <Box
      bgImage={`url(${BackGroundImage})`}
      bgRepeat="no-repeat"
      bgAttachment="fixed"
      bgSize="cover"
      bgPosition="center"
      minHeight="100vh"
      w="100%"
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      px={4}
      mt="72px"
    >
      <Box p={4} bg={overlayColor}  mx="auto" my={2} borderRadius={"lg"}>
      <Box maxW="1200px" as="section" id="enrolment" >
        <VStack>
                {/* Logo */}
                <Flex justify="center" mb={6}>
                  <Image
                    src={tenant.logo_url}
                    alt={`${tenant.tenant_name} logo`}
                    boxSize={{ base: "160px", md: "200px" }}
                    objectFit="cover"
                    borderRadius="full"  // ⬅️ makes it fully rounded (circular)
                  />
                </Flex>
        
                {/* Tenant Name */}
                <Text
                  fontSize={{ base: "2xl", md: "4xl" }}
                  fontWeight="bold"
                  color={textColor}
                  mb={2}
                >
                 {tenant.tenant_name}
                </Text>
                </VStack>
      <Text fontSize="2xl" fontWeight="bold">{"Student Enrolment"}</Text> 
     
        <Box mt={2} whiteSpace="pre-line" fontSize="md">
            <Text>
            It is a step in right direction to enroll for the desired course/exam in {tenant.tenant_name}, 
            let us now assist you to fill in the details as laid out in each section. As you will submit the enrolment request, you will receive a {tenant.tenant_name} Registration Number. 
            Please keep this number for future reference and correspondence, this no. will be unique for each Student Enrolment.
            </Text>
        </Box>    
      </Box>
      <Box  mb={2}>
      <EnrolmentForm mode="public" tenantId={tenant.tenant_id} tenantName={tenant.tenant_name} onSave={savePublicEnrolment} formReset={formReset} />
      </Box>
        {/* Confirmation Modal */}
        <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Duplicate Enrolment Detected</ModalHeader>
          <ModalBody>
            <Text>
              A similar enrolment already exists. Confirm to proceed if this is
              a new enrolment.
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="teal" mr={3} onClick={handleConfirm}>
              Confirm and Proceed
            </Button>
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Box maxW="1200px" mx="auto" my={2}>
      {/* Display Enrolment ID */}
      {enrolmentNo && (
        <Text mt={4} fontSize="lg" color="teal.600">
          Your Enrolment Number is: {enrolmentNo}
        </Text>
      )}
      </Box>
      </Box>
      </Box>
        
  );
};

export default EnrolmentPage;
